import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    SettingsContractType,
    GetSettingsContractsTypesParams,
    CreateSettingsContractTypePayload,
    UpdateSettingsContractTypePayload
} from './types/settings-contract-types'

type ApiGetSettingsContractTypesResponse = Promise<AxiosResponse<{ data: SettingsContractType[], meta: { last_page: number } }>>
type ApiCreateSettingsContractTypeResponse = Promise<AxiosResponse<void>>
type ApiUpdateSettingsContractTypeResponse = Promise<AxiosResponse<void>>
type ApiDeleteSettingsContractTypeResponse = Promise<AxiosResponse<void>>

export function getSettingsContractTypes(params: GetSettingsContractsTypesParams): ApiGetSettingsContractTypesResponse {
    return http.get('/contract/api/type', { params })
}

export function createSettingsContractType(payload: CreateSettingsContractTypePayload): ApiCreateSettingsContractTypeResponse {
    return http.post('/contract/api/type', payload)
}

export function updateSettingsContractType(typeId: number, payload: UpdateSettingsContractTypePayload): ApiUpdateSettingsContractTypeResponse {
    return http.put(`/contract/api/type/${typeId}`, payload)
}

export function deleteSettingsContractType(typeId: number): ApiDeleteSettingsContractTypeResponse {
    return http.delete(`/contract/api/type/${typeId}`)
}

export default {
    getSettingsContractTypes,
    createSettingsContractType,
    updateSettingsContractType,
    deleteSettingsContractType
}
